module.exports = __webpack_public_path__ + "img/解决方案_BMS_绿.e4aa69a1.svg";